import React, { useEffect } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Properties, systemConfiguration, includeScripts, includeBootstrapCss, includeBundleBootstrapCss } from '../../../src/CommonImports';
import 'bootstrap/dist/css/bootstrap.min.css';
import './../css/GCandGridCard.css';

function GCandGridCardLeftSidebar() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';

    useEffect(() => {
        includeBootstrapCss();
        includeBundleBootstrapCss();
        includeScripts();

        document.addEventListener('DOMContentLoaded', function () {
            if (window.innerWidth >= 992) {
                const sidebar = Offcanvas(document.getElementById(Properties.SIDEBAR_MENU_PROP));
                if (sidebar && sidebar.show) sidebar.show();
            }
        });
    }, []);

    return (
            
            <div className ="col-lg-3 col-md-12 col-sm-12">

                <div className ="bg-primary p-4 rounded mb-4">
                    <h5 className ="fw-semibold mb-3">Set Job Reminder</h5>
                    <p className ="text-white">Enter your email address and get job notification.</p>
                    <form>
                        <div className ="mb-3 position-relative">
                            <input type="email" className ="form-control ps-5" placeholder="Enter email address" />
                            <i className ="fi fi-rr-envelope position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                        </div>
                        <button type="submit" className ="btn btn-outline-light w-100">Submit</button>
                    </form>
                </div>


                <div className ="bg-white shadow-sm p-4 border rounded mb-4">

                    <div className ="mb-4">
                        <h5 className ="fw-semibold mb-3">Location</h5>
                        <div className ="position-relative">
                            <input type="text" className ="form-control ps-5" placeholder="Location" />
                            <i className ="fi fi-rr-marker position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                        </div>
                    </div>


                    <div className ="mb-4">
                        <h5 className ="fw-semibold mb-3">Category</h5>
                        <div className ="position-relative">
                            <select className ="form-select ps-5">
                                <option selected>UI/UX Design</option>
                                <option>UI/UX Design 1</option>
                                <option>UI/UX Design 2</option>
                                <option>UI/UX Design 3</option>
                            </select>
                            <i className ="fi fi-rr-briefcase position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                        </div>
                    </div>


                    <div className ="mb-4">
                        <h5 className ="fw-semibold mb-3">Job Type</h5>
                        <ul className ="list-unstyled">
                            <li className ="d-flex justify-content-between align-items-center mb-2">
                                <div className ="form-check">
                                    <input className ="form-check-input" type="checkbox" />
                                    <label className ="form-check-label">Full Time Jobs</label>
                                </div>
                                <span className ="badge bg-light text-dark">235</span>
                            </li>
                            <li className ="d-flex justify-content-between align-items-center mb-2">
                                <div className ="form-check">
                                    <input className ="form-check-input" type="checkbox" checked />
                                    <label className ="form-check-label">Part Time Jobs</label>
                                </div>
                                <span className ="badge bg-light text-dark">28</span>
                            </li>
                            <li className ="d-flex justify-content-between align-items-center mb-2">
                                <div className ="form-check">
                                    <input className ="form-check-input" type="checkbox" checked />
                                    <label className ="form-check-label">Remote Jobs</label>
                                </div>
                                <span className ="badge bg-light text-dark">67</span>
                            </li>
                            <li className ="d-flex justify-content-between align-items-center mb-2">
                                <div className ="form-check">
                                    <input className ="form-check-input" type="checkbox" />
                                    <label className ="form-check-label">Freelance</label>
                                </div>
                                <span className ="badge bg-light text-dark">92</span>
                            </li>
                            <li className ="d-flex justify-content-between align-items-center">
                                <div className ="form-check">
                                    <input className ="form-check-input" type="checkbox" />
                                    <label className ="form-check-label">Temporary</label>
                                </div>
                                <span className ="badge bg-light text-dark">14</span>
                            </li>
                        </ul>
                    </div>


                    <div className ="mb-4">
                        <h5 className ="fw-semibold mb-3">Experience Level</h5>
                        <ul className ="list-unstyled">
                            <li className ="d-flex justify-content-between align-items-center mb-2">
                                <div className ="form-check">
                                    <input className ="form-check-input" type="checkbox" />
                                    <label className ="form-check-label">Expert</label>
                                </div>
                                <span className ="badge bg-light text-dark">76</span>
                            </li>
                            <li className ="d-flex justify-content-between align-items-center mb-2">
                                <div className ="form-check">
                                    <input className ="form-check-input" type="checkbox" />
                                    <label className ="form-check-label">Senior</label>
                                </div>
                                <span className ="badge bg-light text-dark">89</span>
                            </li>
                            <li className ="d-flex justify-content-between align-items-center mb-2">
                                <div className ="form-check">
                                    <input className ="form-check-input" type="checkbox" checked />
                                    <label className ="form-check-label">Junior</label>
                                </div>
                                <span className ="badge bg-light text-dark">54</span>
                            </li>
                            <li className ="d-flex justify-content-between align-items-center mb-2">
                                <div className ="form-check">
                                    <input className ="form-check-input" type="checkbox" checked />
                                    <label className ="form-check-label">Regular</label>
                                </div>
                                <span className ="badge bg-light text-dark">23</span>
                            </li>
                            <li className ="d-flex justify-content-between align-items-center mb-2">
                                <div className ="form-check">
                                    <input className ="form-check-input" type="checkbox" />
                                    <label className ="form-check-label">Internship</label>
                                </div>
                                <span className ="badge bg-light text-dark">22</span>
                            </li>
                            <li className ="d-flex justify-content-between align-items-center">
                                <div className ="form-check">
                                    <input className ="form-check-input" type="checkbox" />
                                    <label className ="form-check-label">Associate</label>
                                </div>
                                <span className ="badge bg-light text-dark">14</span>
                            </li>
                        </ul>
                    </div>


                    <div className ="mb-4">
                        <h5 className ="fw-semibold mb-3">Salary Range</h5>

                        <div className ="row g-2">
                            <div className ="col-6">
                                <label className ="form-label">From</label>
                                <input type="text" className ="form-control" value="$1500" disabled />
                            </div>
                            <div className ="col-6">
                                <label className ="form-label">To</label>
                                <input type="text" className ="form-control" value="$60000" disabled />
                            </div>
                        </div>
                    </div>


                    <div className ="d-flex gap-2">
                        <button className ="btn btn-primary w-50">Apply Filter</button>
                        <button className ="btn btn-outline-secondary w-50">Reset Filter</button>
                    </div>
                </div>


                <div className ="bg-primary text-white p-4 rounded">
                    <h5 className ="fw-semibold mb-3">Recruiting?</h5>
                    <p className ="text-white mb-4">Advertise your jobs to millions of monthly users and search 16.8 million CVs in our database.</p>
                    <a href="#" className ="btn btn-outline-light w-100">Post a Job</a>
                </div>
            </div>

       

    );
}

export default GCandGridCardLeftSidebar;
